import React from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { disableUser } from '../redux/actions/user';

import AdornedButton from './AdornedButton';
import RTVDialog from './dialogs/RTVDialog';
import RTVSwitch from './RTVSwitch';
import {
  DISABLE_USER_REQUESTED,
  DISABLE_USER_ERRORED
} from '../redux/actions/types';
import { useTranslation } from 'react-i18next';

const RTVDisableUser = ({ status, disableUser, switchProps = {} }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [confirmation, setConfirmation] = React.useState(false);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    if (status === DISABLE_USER_REQUESTED) {
      setLoading(true);
    }
    if (status === DISABLE_USER_ERRORED) {
      setLoading(false);
      setConfirmation(false);
      setError(true);
    }
  }, [status]);

  const onChange = () => {
    if (loading) {
      return;
    }

    setConfirmation(true);
  };

  return (
    <>
      <RTVDialog
        open={confirmation}
        onClose={() => setConfirmation(false)}
        title={t('deletingAccount', { ns: 'dresser' })}
        content={
          <Typography style={{ textAlign: 'center' }}>
            Se borrarán tus productos y pedidos.
            <br />
            Estás segura?
          </Typography>
        }
        actionSection={
          <>
            <Button
              variant="contained"
              color="secondary"
              disabled={loading}
              onClick={() => setConfirmation(false)}
            >
              Cancelar, me arrepentí
            </Button>
            <AdornedButton
              variant="contained"
              color="primary"
              loading={loading}
              disabled={loading}
              onClick={() => disableUser()}
            >
              SÍ! ELIMINAR MI CUENTA
            </AdornedButton>
          </>
        }
      />
      <RTVDialog
        open={error}
        onClose={() => setError(false)}
        title="Ups"
        message="No podés eliminar tu cuenta porque tenés al menos 1 compra o 1 venta pendiente"
        actionSection={
          <Button
            variant="contained"
            color="primary"
            disabled={loading}
            onClick={() => setError(false)}
          >
            OK
          </Button>
        }
      />
      <RTVSwitch
        disabled={loading}
        checked={false}
        onClick={onChange}
        {...switchProps}
      />
    </>
  );
};

const mapStateToProps = state => ({
  status: state.user.status,
  user: state.user.user
});

const mapDispatchToProps = dispatch => ({
  disableUser: () => dispatch(disableUser())
});

export default connect(mapStateToProps, mapDispatchToProps)(RTVDisableUser);
